<template>
  <div>
    <nav-bar :title="'My Projects'"></nav-bar>
    <div class="mobile pt-4">
      <confirm-modal
        :title="this.modalAttributes.title"
        :confirm-button="this.modalAttributes.confirmButton"
      >
        {{ this.modalAttributes.text }}
      </confirm-modal>
      <b-row v-if="projectId" class="mb-4">
        <b-col class="text-right">
          <b-spinner v-if="isBeingSaved" label="Spinning"></b-spinner>
          <div v-else>
            <b-button
              v-if="readonly"
              @click="onEdit"
              v-b-tooltip.hover="'Edit Project'"
              class="bg-transparent text-dark border-0"
            >
              <i class="material-icons ">border_color</i>
            </b-button>
            <b-button
              v-if="projectId"
              @click="openDeleteConfirmation"
              v-b-tooltip.hover="'Delete Project'"
              class="bg-transparent text-dark border-0"
            >
              <i class="material-icons ">delete</i>
            </b-button>
          </div>
        </b-col>
      </b-row>
      <project-create-form
        :project="project"
        :typeClass="typeClass"
        :readonly="readonly"
        @createOrEditProject="createOrEditProject"
      ></project-create-form>
    </div>
  </div>
</template>

<script>
import { getClasses } from '@/module/services';
import { setNewProject, getProjectInfo, editProject, deleteProject } from '@/myTasks/services/';
import { useSessionStore } from '@/common';
import { NavBar } from '@/common/components';
import { ConfirmModal } from '@/common/components';
import ProjectCreateForm from '@/myTasks/components/ProjectCreateForm';

export default {
  components: {
    NavBar,
    ConfirmModal,
    ProjectCreateForm,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      project: {},
      classes: [],
      modalAttributes: {},
      readonly: false,
      isBeingSaved: false,
    };
  },
  computed: {
    projectId() {
      return this.$route.query.project;
    },
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    getChildId() {
      return this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    },
    typeClass() {
      if (!this.classes.length) return [];
      const classes = this.classes.map(({ id: value, name: text, ...rest }) => ({
        value,
        text,
        ...rest,
      }));

      return [{ value: null, text: 'Select a class' }, ...classes];
    },
  },
  methods: {
    async createOrEditProject({ newProject }) {
      this.isBeingSaved = true;
      if (this.projectId) {
        try {
          await editProject(this.projectId, this.getChildId, newProject);
          this.$router.push({ name: 'myProjects' });
        } catch (error) {
          console.log(error);
        }
        return;
      }

      try {
        await setNewProject(this.getChildId, newProject);
        this.$router.push({ name: 'myProjects' });
      } catch (error) {
        console.log(error);
      }
    },
    filterActiveClasses(classes) {
      return classes.filter((item) => item.state);
    },
    async getProject() {
      if (!this.projectId) return;
      this.project = await getProjectInfo(this.projectId);
    },
    isReadonly(readonly) {
      this.readonly = readonly && !!this.projectId;
    },
    onEdit() {
      this.isReadonly(false);
    },
    openDeleteConfirmation() {
      this.modalAttributes = {
        title: 'Delete Project',
        text: 'Are you sure you want to delete this project?',
        confirmButton: this.onDelete,
      };
      this.$bvModal.show('confirmModal');
    },
    async onDelete() {
      this.isBeingSaved = true;
      this.isReadonly(true);
      try {
        await deleteProject(this.projectId, this.getChildId);
        this.$router.push({
          name: 'myProjects',
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
  async mounted() {
    this.isReadonly(true);
    try {
      await this.getProject();
      const classes = await getClasses(this.getChildId);
      this.classes = this.filterActiveClasses(classes);
    } catch (error) {
      console.error(error);
    }
  },
};
</script>

